export default function Header({ children }) {
    return (
        <header className="sticky z-10 top-0 w-screen bg-white border-b border-gray-200">
            <div className="max-w-6xl mx-auto flex items-center justify-center py-4">
                <img
                    src="/logo.jpg"
                    alt="נשים לגופן - Women and Their Bodies"
                    className="h-20"
                />
            </div>

            {/* Progress bar below logo */}
            {children}
        </header>
    );
}